import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import {Button, LoadingIndicator, Panel} from '../../../components'
import {Container, FlowSummaryLastPanelItem, FlowSummaryPanelItem, Link, Title} from '../../flow'
import Costs from '../containers/costs'
import TextField from 'material-ui/TextField'
import Dialog, {DialogActions, DialogContent, DialogTitle} from 'material-ui/Dialog'
import List, {ListItem} from 'material-ui/List'
import {paymentMethod as text} from '../../profile/text'
import {CardIcon} from '../../../common/components/CreditCardInput'
import OfflineIcon from 'material-ui-icons/PhonelinkOff'
import Typography from 'material-ui/Typography'
import MUIButton from 'material-ui/Button'
import {formatAddress} from '../../../common/format'
import Check from '../../flow/components/check'
import {PRICES_AVAILABLE} from '../../../App'

const styles = (theme) => ({
  container: {maxWidth: 328, margin: '0 auto'},
  title: {marginBottom: 20},
  button: {margin: '5px 0'},
  noCatalogsMessage: {
    marginTop: 35,
    color: 'rgba(0,0,0,.54)',
    textAlign: 'center',
  },
  textContainer: {
    padding: '0 10px',
  },
  lastActionContainer: {
    padding: '5px 16px',
    textAlign: 'right',
  },
})

class SummaryStep extends React.Component {

  static displayName = 'SummaryStep.component'

  state = {
    open: false,
    cardError: false,
    selectedOffline: false,
    termsChecked: false,
    termsError: false,
  }

  componentDidMount() {
    this.props.updateUrl()
  }

  onTermsChange = (e) => this.setState({termsChecked: e.target.checked, termsError: false})

  render() {
    const {classes, requireCardForDeposit, address, date, card, transactionCost, comment, isConfirming} = this.props
    return (
      <Container className={classes.container}>
        <Costs/>
        <Title className={classes.title}>Chequea la información:</Title>
        <Panel>
          <FlowSummaryPanelItem
            title={'Dirección de retiro'}
            description={formatAddress(address.Address, address.Number, address.Floor, address.Apartment, '')}
            actionLabel={'Modificar'}
            onClick={() => this.props.requestPreviousStep()}
          />
          <FlowSummaryPanelItem
            title={'Día y horario'}
            description={date.format('LLL')}
            actionLabel={'Modificar'}
            onClick={() => this.props.requestPreviousStep()}
          />
          <FlowSummaryPanelItem
            title={'Método de Pago'}
            description={
              this.state.selectedOffline === true
                ? 'Pago offline'
                : card ? `${card.Type} terminada en ${card.LastDigits}` : 'Seleccionar'
            }
            actionLabel={'Modificar'}
            onClick={() => this.setState({open: true, cardError: false})}
            error={this.state.cardError}
            warning={this.state.selectedOffline === false && !card}
          />
          {PRICES_AVAILABLE &&
          <FlowSummaryLastPanelItem
            rows={[{
              label: 'Costo de retiro',
              value: transactionCost === 0 ? '¡GRATIS!' : transactionCost,
              valueColor: transactionCost === 0 ? 'secondary' : 'white',
            }]}
          />
          }
        </Panel>
        <TextField
          fullWidth={true}
          label={'Comentarios'}
          style={{margin: '15px 0 15px 0'}}
          value={comment}
          onChange={(e) => this.props.setComment(e.target.value)}
        />
        <Check
          style={{marginBottom: 15}}
          checked={this.state.termsChecked}
          error={this.state.termsError}
          onChange={this.onTermsChange}
          text={<span>Leí y acepto los <a href={'https://space.guru/terminos.html'} target={'_blank'}>términos y condiciones</a></span>}
        />
        {PRICES_AVAILABLE &&
        <Button
          variant={'secondary'}
          fullWidth={true}
          className={classes.button}
          onClick={this.props.openCosts}
        >
          Costos de Almacenaje
        </Button>
        }
        <LoadingIndicator show={isConfirming || this.props.loading}>
          <Button
            variant={'primary'}
            fullWidth={true}
            className={classes.button}
            onClick={() => {
              if (this.state.selectedOffline === false && !card) {
                this.setState({cardError: true})
                return
              }

              if (this.state.termsChecked === false) {
                this.setState({termsError: true})
                return
              }

              this.props.confirm()
            }}
          >
            Confirmar
          </Button>
        </LoadingIndicator>
        <SelectCardDialog
          classes={classes}
          open={this.state.open}
          onClose={() => this.setState({open: false})}
          onCancel={() => this.setState({open: false})}
          modalTitle={'Selecciona una tarjeta'}
          options={this.props.cards}
          onSelect={(card) => {
            this.props.selectCard(card)
            this.setState({
              open: false,
              selectedOffline: card === -1,
            })
          }}
          lastAction={{
            label: 'Agregar tarjeta',
            onClick: this.props.goToPayment,
          }}
          allowOffline={requireCardForDeposit === false}
        />
      </Container>
    )
  }

  static propTypes = {
    requireCardForDeposit: PropTypes.bool,
    address: PropTypes.object,
    date: PropTypes.object,
    card: PropTypes.object,
    cards: PropTypes.array,
    comment: PropTypes.string,
    selectCard: PropTypes.func.isRequired,
    setComment: PropTypes.func.isRequired,
    transactionCost: PropTypes.number,
    confirm: PropTypes.func.isRequired,
    isConfirming: PropTypes.bool,
    openCosts: PropTypes.func.isRequired,
    requestPreviousStep: PropTypes.func.isRequired,
    goToPayment: PropTypes.func.isRequired,
    updateUrl: PropTypes.func.isRequired,
  }
}

export default withStyles(styles, {withTheme: true})(SummaryStep)

const SelectCardDialog = ({classes, open, onClose, onCancel, modalTitle, options, onSelect, lastAction, allowOffline}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle align={'center'}>{modalTitle}</DialogTitle>
    <DialogContent style={{minWidth: 320, padding: 0}}>
      <List>
        {options.map(c => (
          <ListItem key={c.ID} button onClick={() => onSelect(c.ID)}>
            <CardIcon type={c.Type} style={{width: 36, height: 36, marginRight: 20}}/>
            <div className={classes.textContainer}>
              <Typography variant={'body1'}
                          color={'textSecondary'}>{`•••• •••• •••• ${c.LastDigits}`} ({c.Type})</Typography>
              <Typography variant={'body1'}
                          color={'textSecondary'}>{text.expiryDate}: {c.Expiration}</Typography>
              <Typography variant={'body1'}
                          color={'textSecondary'}>{c.Main ? 'Tarjeta Primaria' : ''}</Typography>
            </div>
          </ListItem>
        ))}
        {allowOffline && options.length === 0 && (
          <ListItem key={-1} button onClick={() => onSelect(-1)}>
            <OfflineIcon style={{width: 36, height: 36, marginRight: 20}}/>
            <div className={classes.textContainer}>
              <Typography variant={'body1'} color={'textSecondary'}>Pagar offline</Typography>
            </div>
          </ListItem>
        )}
        {lastAction && (
          <div className={classes.lastActionContainer}>
            <Link onClick={lastAction.onClick}>{lastAction.label}</Link>
          </div>
        )}
      </List>
    </DialogContent>
    <DialogActions>
      <MUIButton onClick={onCancel} color={'primary'}>Cancelar</MUIButton>
    </DialogActions>
  </Dialog>
)



// WEBPACK FOOTER //
// ./src/sections/depositV2/components/summary.step.jsx